module.exports = __webpack_public_path__ + "static/level-1.12d98164.png";